<template>
  <div class="sub-account-detail">
    <div class="sub-account-add">
      <div class="add-button" @click="addSubAccount">添加子账号</div>
      <div class="add-introduction">
        <span>注意：初始密码为Founder123，账号分配给使用人登录后，可到</span>
        <a class="user-center-button" target="_blank" :href="userCenterUrl">个人中心</a><span>修改密码，管理员收回账号可直接在此修改子账号密码。</span>
      </div>
    </div>
    <List class="sub-account-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="8">
      <template v-slot:listContent>
        <div class="sub-account-table">
          <el-table class="sub-account-detail-table" :data="tableData" border :header-cell-style="headerCellStyle" :cell-style="cellStyle" empty-text="暂无子账号，可点击“添加子账号”按钮创建。">
            <el-table-column prop="childAccountName" label="账号" min-width="266"> </el-table-column>
            <el-table-column prop="ebookNum" label="作品数量" min-width="266"> </el-table-column>
            <el-table-column label="操作" min-width="266">
              <template slot-scope="scope">
                <div class="option-button-wrapper">
                  <div class="option-button" @click="goList(scope.row)">前往作品列表</div>
                  <div class="option-button" @click="changePassword(scope.row)">修改密码</div>
                  <div class="option-button" @click="changeManageRight(scope.row)">账号权限</div>
                  <div class="option-button" @click="remove(scope.row)">删除账号</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </List>
    <subAccountAddDialog v-if="addDialogShow" :visible="addDialogShow" @clickCancel="addClickCancel" @clickConfirm="addClickConfirm"></subAccountAddDialog>
    <subAccountPasswordDialog v-if="passwordDialogShow" :visible="passwordDialogShow" @clickCancel="passwordClickCancel" @clickConfirm="passwordClickConfirm"></subAccountPasswordDialog>
    <subAccountRemoveDialog :visible="removeDialogShow" @clickCancel="removeClickCancel" @clickConfirm="removeClickConfirm"></subAccountRemoveDialog>
    <sub-permission-modify-dialog ref="permissionDialog" :visible="permissionDialogShow" @clickCancel="permissionClickCancel" @clickConfirm="permissionClickConfirm"></sub-permission-modify-dialog>
    <TipDialog ref="memberDialog" :dialogOptions="memberDialogOptions"></TipDialog>
  </div>
</template>
<script>
import md5 from 'js-md5'
import subAccountAddDialog from '@components/subAccount/subAccountAddDialog.vue'
import subAccountRemoveDialog from '@components/subAccount/subAccountRemoveDialog.vue'
import subAccountPasswordDialog from '@components/subAccount/subAccountPasswordDialog.vue'
import compareVipRight from '@components/common/compareVipRight.js'
import TipDialog from '@components/common/TipDialog.vue'
import subAccountApi from '@api/subAccount.js'
import List from '@components/list/listFrame'
import SubPermissionModifyDialog from '@components/subAccount/subPermissionModifyDialog'

export default {
  name: 'SubAccountDetail',
  mixins: [compareVipRight],
  data() {
    return {
      currentSubAccount: null,
      currentPageNo: 1,
      pageSize: 8,
      totalCount: 0,
      addDialogShow: false, //添加子账号弹窗是否显示
      removeDialogShow: false, //删除子账号弹窗是否显示
      passwordDialogShow: false, //修改密码弹窗是否显示
      permissionDialogShow: false, //修改权限弹窗是否显示
      userCenterUrl: `${window.PROJECT_CONFIG.BASE_URL}/ucenter/user.jhtml`, //个人中心
      tableData: [], //子账号列表数据
      headerCellStyle: { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }, //子账号列表样式
      cellStyle: { 'text-align': 'center' } //子账号列表样式
    }
  },
  computed: {
    userName() {
      return this.$store.getters['common/userName']
    },
    memberDialogOptions() {
      return {
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，仅允许创建${this.$store.state.common.vipRight.childAccountNum}个子账号，创建更多需先升级会员服务。`
      }
    }
  },
  methods: {
    // 获取子账号列表
    getList() {
      let param = {
        pageNo: this.currentPageNo,
        pageSize: this.pageSize
      }
      subAccountApi.getSubAccountList(param).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.tableData = res.data.data.page.result
          this.totalCount = res.data.data.page.totalCount || 0
        }
      })
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getList()
    },
    async addSubAccount() {
      if (await this.compare({ type: 'num', key: 'childAccountNum', value: this.totalCount })) {
        this.addDialogShow = true
      } else {
        if (this.$store.state.common.vipRight.childAccountNum === 0) {
          this.memberDialogOptions.tip = `您当前为${this.$store.state.common.vipRight.name}，若想创建子账号需要升级会员服务。`
        }
        this.$refs.memberDialog.visible = true
      }
    },
    goList(val) {
      this.$store.commit('manage/UPDATE_BOOKS_CURRENT_ACCOUNT', val.childAccountName)
      this.$router.push('/list')
    },
    changePassword(param) {
      this.currentSubAccount = param
      this.passwordDialogShow = true
    },
    changeManageRight(param) {
      this.currentSubAccount = param
      this.$refs.permissionDialog.radioValue = param?.managePaper || 0
      this.permissionDialogShow = true
    },
    remove(param) {
      this.currentSubAccount = param
      this.removeDialogShow = true
    },
    addClickCancel() {
      this.addDialogShow = false
    },
    async addClickConfirm(num) {
      if (await this.compare({ type: 'num', key: 'childAccountNum', value: this.tableData.length - 1 + num })) {
        // let userNameNum = this.tableData.length > 0 ? Number(this.tableData[this.tableData.length - 1].userName.split('-')[1]) + 1 : 1
        // for (let i = 0; i < num; i++) {
        //   this.tableData.push({ userName: `${this.userName}-${userNameNum}`, password: 'Founder123', count: 0 })
        //   userNameNum++
        // }
        subAccountApi.addSubAccount({ childNum: num }).then((res) => {
          if (res.status === 200 && res.data.code == 0) {
            this.getList()
          } else {
            this.$alert(res.data.msg || '创建失败', '提示', {
              confirmButtonText: '确定'
            })
          }
          this.addDialogShow = false
        })
      } else {
        this.$refs.memberDialog.visible = true
        this.addDialogShow = false
      }
    },
    passwordClickCancel() {
      this.passwordDialogShow = false
    },
    passwordClickConfirm(password) {
      subAccountApi.modifyPassword({ childLoginName: this.currentSubAccount.childAccountName, password: md5(password) }).then((res) => {
        if (res.status === 200) {
          this.$alert(res.data.msg || '修改失败', '提示', {
            confirmButtonText: '确定'
          })
        }
      })
      this.passwordDialogShow = false
    },
    removeClickCancel() {
      this.removeDialogShow = false
    },
    removeClickConfirm() {
      subAccountApi.removeSubAccount({ childName: this.currentSubAccount.childAccountName }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          if (this.tableData.length === 1 && this.currentPageNo > 1) {
            this.currentPageNo--
          }
          this.getList()
        } else {
          this.$alert(res.data.msg || '删除失败', '提示', {
            confirmButtonText: '确定'
          })
        }
        this.removeDialogShow = false
      })
    },
    permissionClickCancel() {
      this.permissionDialogShow = false
    },
    permissionClickConfirm(value) {
      subAccountApi.setManagePaper({ childName: this.currentSubAccount.childAccountName, managePaper: value }).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.getList()
        } else {
          this.$alert(res.data.msg || '修改失败', '提示', {
            confirmButtonText: '确定'
          })
        }
        this.permissionDialogShow = false
      })
    }
  },
  mounted() {
    this.getList()
  },
  components: {
    SubPermissionModifyDialog,
    subAccountAddDialog,
    subAccountRemoveDialog,
    subAccountPasswordDialog,
    TipDialog,
    List
  }
}
</script>
<style lang="scss" scoped>
.sub-account-detail {
  padding: 0 13px;
  min-width: 800px;
  .sub-account-add {
    padding: 4px 0;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .add-button {
      width: 180px;
      height: 46px;
      border-radius: 25px;
      color: #fff;
      font-size: 18px;
      background-color: #df5813;
      text-align: center;
      line-height: 46px;
      margin-right: 20px;
      flex-shrink: 0;
      cursor: pointer;
    }
    .add-introduction {
      .user-center-button {
        color: #df5813;
        text-decoration: none;
      }
    }
  }
  /deep/ .common-list {
    padding-top: 0;
    max-height: calc(100vh - 264px);
  }
  .sub-account-table {
    width: 100%;
    /deep/ .sub-account-detail-table {
      width: 100%;
      max-height: 100%;
      .option-button-wrapper {
        display: inline-flex;
        justify-content: space-around;
        width: 100%;
        .option-button {
          color: #df5813;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }
}
</style>
